<template>
    <div class="form-selection-panel mt-2 overflow-hidden">
        <template v-for="feature in features" :key="feature.id">
            <div
                v-if="feature.activation === 'always'"
                class="form-selection-option flex items-center justify-between px-3 py-2"
            >
                <span class="text-sm text-gray-700">{{ $t(feature.label) }}</span>
                <span class="text-xs text-gray-500">{{ $t('Always enabled') }}</span>
            </div>
            <label
                v-else
                :class="[
                    'form-selection-option flex items-center px-3 py-2',
                    isForced(feature) ? 'cursor-default' : 'cursor-pointer',
                ]"
            >
                <input
                    :checked="isChecked(feature)"
                    :disabled="isForced(feature)"
                    class="form-checkbox h-4 w-4 text-gray-700 mr-3"
                    type="checkbox"
                    @change="updateFeature(feature, $event)"
                >
                <span class="text-sm text-gray-700">{{ $t(feature.label) }}</span>
            </label>
        </template>
    </div>
</template>

<script>
import {isUserSystemFeatureForced} from '@/utils/user-system-features';

export default {
    name: 'user-system-feature-list',
    props: {
        features: {
            type: Array,
            required: true,
        },
        roleGroup: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },
    },
    emits: ['change'],
    methods: {
        isForced(feature) {
            return isUserSystemFeatureForced(feature, this.roleGroup);
        },
        isChecked(feature) {
            return this.isForced(feature) || !!this.value[feature.field];
        },
        updateFeature(feature, event) {
            this.$emit('change', {
                field: feature.field,
                value: !!event.target.checked,
            });
        },
    },
};
</script>
